import { useState, useCallback } from "react";
import type { DocumentTypeInfoViewModel } from "@models/doctype";
import { docTypeApi } from "@src/services/doctypeApi";

export interface IDoctypeState {
  doctypes: DocumentTypeInfoViewModel[];
  isLoading: boolean;
  error: string | null;
  fetchDoctypes: () => Promise<void>;
}

export const useDoctype = (): IDoctypeState => {
  const [doctypes, setDoctypes] = useState<DocumentTypeInfoViewModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDoctypes = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await docTypeApi.getDoctypes();
      setDoctypes(response);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to fetch document types";
      setError(errorMessage);
      console.error("Error fetching document types:", err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    doctypes,
    isLoading,
    error,
    fetchDoctypes,
  };
};
